import { getStore } from '../store/findInMessageStore';

// this function returns the total number of matches for the given context
// for example, if we have 3 item parts, with the first one collapsed and the second and third expanded,
// the matchesPerItemId might look like this:
// [[itemId1, 0, false, false],
//  [itemId1, 0, false, true],
//  [itemId2, 5, true, false]
//  [itemId2, 10, true, true]
//  [itemId3, 3, true, false]
//  [itemId3, 6, true, true]]
// then the function would return 24
export default function getTotalNumberOfMatches(context: string): number {
    const store = getStore();
    const viewState = store.findInMessageViewStates.get(context);
    if (viewState) {
        let numberMatches = 0;
        if (viewState.matchesPerItemId) {
            for (const [_, value] of viewState.matchesPerItemId.entries()) {
                numberMatches += value.numberOfMatches ?? 0;
            }
        }

        return numberMatches;
    }

    return 0;
}
